import { Fragment } from 'react';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { getData } from 'conversations-async-data/async-data/operators/getters';
import { useAsyncForm } from 'conversations-thread-data/forms/hooks/useAsyncForm';
import { getEntryUrlContext, getUrl
// @ts-expect-error module not typed
} from 'conversations-message-history/context-update/operators/contextUpdateGetters';
import { getEditFormRulesUrl } from '../../../urls/inboxSettingsUrls';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { BlankIcon, InfoIcon } from 'foundations-assets';
import SystemMessage from 'conversations-inbox-message-history/system-message/SystemMessage';
// @ts-expect-error module not typed
import { getTimestamp } from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FormContextSystemUpdate = ({
  inboxId,
  formId,
  message,
  ungatedForThreadMessagesUIImprovements
}) => {
  const {
    asyncForm
  } = useAsyncForm({
    formId
  });
  const form = getData(asyncForm);
  const getFormLink = () => form && /*#__PURE__*/_jsx(Link, {
    href: getEditFormRulesUrl({
      formId: form.get('id'),
      inboxId
    }),
    external: true,
    use: "blue",
    truncate: true,
    truncateStringProps: {
      matchContentWidth: true,
      useFlex: false,
      tooltip: false
    },
    children: form.get('name')
  });
  const getEntryUrl = entryUrl => {
    const submittedFromUrl = /*#__PURE__*/_jsx(Link, {
      href: getUrl(entryUrl),
      external: true,
      use: "blue",
      children: getUrl(entryUrl)
    });
    return /*#__PURE__*/_jsx(SystemMessage, {
      description: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: 'conversations-thread-view.threadHistory.context-update-message.form.formSubmissionLink',
        options: {
          entryUrl: submittedFromUrl
        }
      }, 'form-source-link'),
      icon: /*#__PURE__*/_jsx(IconCircle, {
        borderWidth: "0",
        icon: BlankIcon,
        size: "500"
      }),
      ungatedForThreadMessagesUIImprovements: ungatedForThreadMessagesUIImprovements
    });
  };
  const entryUrl = getEntryUrlContext(message);
  let linkText = null;
  let sourceText = /*#__PURE__*/_jsx(SystemMessage, {
    timestamp: getTimestamp(message),
    description: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: 'conversations-thread-view.threadHistory.context-update-message.unknownSourceMessage'
    }, 'form-source-message'),
    icon: /*#__PURE__*/_jsx(IconCircle, {
      borderWidth: "0",
      icon: InfoIcon,
      size: "500"
    })
  });
  if (form) {
    sourceText = /*#__PURE__*/_jsx(SystemMessage, {
      timestamp: getTimestamp(message),
      description: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: 'conversations-thread-view.threadHistory.context-update-message.form.formSubmission',
        options: {
          formLink: getFormLink()
        }
      }, 'form-source-message'),
      icon: /*#__PURE__*/_jsx(IconCircle, {
        borderWidth: "0",
        icon: InfoIcon,
        size: "500"
      })
    });
  }
  if (entryUrl) {
    linkText = getEntryUrl(entryUrl);
  }
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      children: sourceText
    }), /*#__PURE__*/_jsx("div", {
      children: linkText
    })]
  });
};
FormContextSystemUpdate.displayName = 'FormContextSystemUpdate';
export default FormContextSystemUpdate;